import { ExternalLink, Mail } from "lucide-react";
import { toast } from "sonner";

const CHASE_EMAIL = "clang8858@gmail.com";

const CARDS = [
  { name: "Apple Store", tag: "Tech & accessories", url: "https://www.apple.com/shop/gift-cards", color: "from-zinc-700 to-zinc-900" },
  { name: "Amazon", tag: "Everything else", url: "https://www.amazon.com/gift-cards", color: "from-amber-700/60 to-zinc-900" },
  { name: "Whole Foods", tag: "Healthy groceries", url: "https://www.wholefoodsmarket.com/gift-cards", color: "from-green-800/60 to-zinc-900" },
  { name: "Dick's Sporting Goods", tag: "Gear & equipment", url: "https://www.dickssportinggoods.com/s/gift-cards", color: "from-emerald-800/60 to-zinc-900" },
  { name: "Adidas", tag: "Cleats & training wear", url: "https://www.adidas.com/us/giftcards", color: "from-zinc-600 to-zinc-900" },
  { name: "Target", tag: "Dorm & everyday", url: "https://www.target.com/c/gift-cards", color: "from-red-800/60 to-zinc-900" },
  { name: "Thorne", tag: "Supplements & recovery", url: "https://www.thorne.com", color: "from-blue-900/60 to-zinc-900" },
  { name: "Visa / Mastercard", tag: "Flexible spending", url: "https://www.giftcards.com", color: "from-purple-800/60 to-zinc-900" },
];

export default function GiftCards() {
  return (
    <section id="giftcards" className="py-24 md:py-32 bg-zinc-900/50 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="font-sub text-xs tracking-[0.2em] uppercase font-bold text-purple-400 mb-3">Instant Gifting</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase mb-4">
          Gift <span className="text-purple-400">Cards</span>
        </h2>
        <p className="font-sub text-base md:text-lg text-zinc-400 max-w-2xl mb-6">
          The easiest way to help. Buy a digital gift card and email it straight to Chase —
          he'll put it to good use, we promise.
        </p>
        <button
          data-testid="chase-email-copy-btn"
          onClick={() => {
            try {
              navigator.clipboard.writeText(CHASE_EMAIL);
              toast.success("Chase's email copied!");
            } catch {
              toast.error("Couldn't copy — email is " + CHASE_EMAIL);
            }
          }}
          className="group inline-flex items-center gap-3 rounded-full bg-zinc-950 border border-purple-500/40 hover:border-purple-400 px-6 py-3 mb-12 transition-colors duration-200 active:scale-95"
        >
          <Mail className="w-4 h-4 text-purple-400" />
          <span className="font-sub text-sm text-zinc-400">Send digital gift cards to</span>
          <span data-testid="chase-email" className="font-sub text-sm font-bold text-white">{CHASE_EMAIL}</span>
          <span className="font-sub text-xs text-purple-400 group-hover:text-purple-300">tap to copy</span>
        </button>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {CARDS.map((c) => (
            <a
              key={c.name}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`giftcard-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`group relative rounded-2xl bg-gradient-to-br ${c.color} border border-white/5 hover:border-purple-500/50 p-6 aspect-[8/5] flex flex-col justify-between hover:-translate-y-1 transition-[transform,border-color] duration-300`}
            >
              <div className="flex justify-between items-start">
                <span className="w-8 h-6 rounded bg-white/10 border border-white/10" />
                <ExternalLink className="w-4 h-4 text-zinc-500 group-hover:text-purple-400 transition-colors duration-200" />
              </div>
              <div>
                <h3 className="font-sub font-bold text-white text-sm sm:text-base">{c.name}</h3>
                <p className="text-xs text-zinc-400 mt-1">{c.tag}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
